import React from 'react';
import { getStaticContent } from '../constants/staticContent';

const UsageSection = ({ language = 'en' }) => {
  const { USAGE_CONTENT } = getStaticContent(language);
  return (
    <section id="usage" className="min-h-screen flex flex-col justify-center bg-white py-20 px-4 md:px-8">
      <div className="max-w-7xl mx-auto w-full">
        {/* Header */}
        <div className="text-center mb-16 md:mb-24">
          <div className="inline-block mb-4">
            <span
              className="text-xs font-bold tracking-widest uppercase text-emerald-700 bg-emerald-50 px-4 py-1.5 rounded-full border border-emerald-200"
            >
              {USAGE_CONTENT.sectionLabel}
            </span>
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            {USAGE_CONTENT.sectionTitle}
          </h2>
          <p className="text-base md:text-lg text-gray-600 leading-relaxed max-w-3xl mx-auto">
            {USAGE_CONTENT.description}
          </p>
        </div>

        {/* Steps */}
        <div className="relative mb-20 md:mb-24">
          {/* Connector Line (Desktop Only) */}
          <div className="hidden lg:block absolute top-12 left-[10%] right-[10%] h-[2px] border-t-2 border-dashed border-emerald-200 z-0"></div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10 relative z-10">
            {USAGE_CONTENT.steps.map((step, index) => (
              <div
                key={index}
                className="relative bg-white rounded-2xl p-7 md:p-9 transition-all duration-300 transform"
                style={{
                  border: '1px solid rgba(0,0,0,0.06)',
                  boxShadow: '0 2px 12px rgba(0,0,0,0.07)',
                }}
                onMouseEnter={e => {
                  e.currentTarget.style.transform = 'translateY(-3px)';
                  e.currentTarget.style.boxShadow = '0 8px 28px rgba(0,0,0,0.12)';
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 12px rgba(0,0,0,0.07)';
                }}
              >
                {/* Step Number */}
                <div
                  className="absolute -top-5 left-8 bg-emerald-600 text-white rounded-full flex items-center justify-center font-bold text-base shadow-md"
                  style={{ width: '40px', height: '40px' }}
                >
                  {step.stepNumber}
                </div>
                
                {/* Icon */}
                <div className="mb-5 mt-4 w-12 h-12 md:w-16 md:h-16 flex items-center justify-center bg-emerald-50 rounded-2xl">
                  <step.image className="text-emerald-600 w-6 h-6 md:w-8 md:h-8" />
                </div>
                
                {/* Title */}
                <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3">
                  {step.title}
                </h3>
                
                {/* Description */}
                <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                  {step.description}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Package Contents */}
        <div className="max-w-4xl mx-auto">
          <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-8 text-center">
            {USAGE_CONTENT.packageHeading}
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {USAGE_CONTENT.packageIncludes.map((item, index) => (
              <div
                key={index}
                className="flex items-center gap-4 bg-white p-5 transition-shadow duration-300 hover:shadow-md"
                style={{
                  border: '1px solid #E5E7EB',
                  borderRadius: '10px',
                  boxShadow: '0 1px 4px rgba(0,0,0,0.04)'
                }}
              >
                <div className="bg-emerald-500 rounded-full flex-shrink-0" style={{ width: '8px', height: '8px' }}></div>
                <span className="text-sm md:text-base text-gray-600 leading-relaxed">{item}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16 md:mt-20">
          <a
            href="#downloads"
            className="inline-flex items-center gap-3 px-8 py-4 bg-emerald-600 text-white font-bold rounded-xl hover:bg-emerald-700 transition-all duration-300 shadow-lg hover:shadow-xl text-base"
          >
            {USAGE_CONTENT.ctaText}
            <span className="text-xl">→</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default UsageSection;
